import React, {Component, useEffect, useState, useRef} from "react";
import ButtonRounded from "../../../components/ButtonRounded";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import ToggleButton from "../../../components/ToggleButton";
import {makeStyles, createStyles, Theme} from "@material-ui/core/styles";
import {FormattedMessage} from "react-intl";
// @ts-ignore
import { State } from "../../../reducers/reducer";
import { useSelector } from "react-redux";
import getAllocationPageData from "../../../api/sustainability/allocation/collaboration/get";
import {useHistory, useRouteMatch} from "react-router-dom";
import {startAllocation} from "../../../reducers/sustainability/allocation/multiStep";
import { hasRoadData, deleteRoadUseData } from "../../../api/sustainability/allocation/roadUse/data";
import {
    hasOffRoadData,
    deleteOffRoadUseData,
    getMandateStatuses
} from "../../../api/sustainability/allocation/offRoadUse/data";
import { brandColors } from "../../../theme";
import { hasMarineData, deleteMarineData } from "../../../api/sustainability/allocation/marineUse/data";
// @ts-ignore
import { toggleSimulation } from "../../../reducers/sustainability/main";
import { useDispatch } from "react-redux";
import resetAllocation from "../../../api/sustainability/allocation/roadUse/stepData";
import {resetAllocationOffroad} from "../../../api/sustainability/allocation/offRoadUse/stepData";
import getDownloadReport, {
    Tfiletype,
    Tmandate_type
} from "../../../api/sustainability/reports/getDownloadReport";
import getDownloadZipReport, {
    Zfiletype
} from "../../../api/sustainability/reports/getDownloadZipReport";
import ModalInfo from "../../../components/modal/ModalInfo";
import { getConfirmState, checkConfirmState } from "../../../api/sustainability/reports/getConfirmState";
import { checkDisableConfirm } from "../../../api/sustainability/reports/getConfirmState";
import ModalConfirmDelivery from "../../../views/DashboardView/SustainabilityView/ReportsView/ModalConfirmDelivery";
import ModalDeleteVolumeInMandate from "../../../components/FilesTable/ModalDeleteVolumeInMandate";
import ButtonSquare from "../../../components/ButtonSquare";
import parseAndFormat from "../../../components/texts/parseAndFormat";
import { arrowProgressBarStyles } from "../../../common/styles/arrowProgressBarStyles";
import { overviewCardStyles } from "../../../common/styles/cardStyles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        h2: {
            [theme.breakpoints.down("md")]: {
                fontSize: "32px",
            },
        },
        btn: {
            minWidth: "200px",
            "&:not(:first-child)": {
                marginLeft: "20px",
                [theme.breakpoints.down("md")]: {
                    marginLeft: "10px",
                },
            },
        },
        buttonMargin: {
            marginBottom: theme.spacing(1),
        },
        toggleButtonMargin: {
            marginBottom: theme.spacing(2),
        },
        toggleCardContainer: {
            marginTop: theme.spacing(3),
        },
        toggleCardContent: {
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
        },
        toggleCardTitle: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        tableTitle: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(3),
        },
        outputTableTopLabel: {
            marginBottom: theme.spacing(1),
            marginLeft: theme.spacing(2),
        },
        table: {
            "& .MuiTableBody-root .MuiTableRow-root:nth-child(odd)": {
                backgroundColor: theme.palette.grey[50],
            },
            "& .MuiTableCell-root": {
                border: "none",
                paddingTop: 0,
                paddingBottom: 0,
                height: theme.spacing(4),
            },
            "& .MuiTableCell-head": {
                color: "inherit",
                fontSize: "11px",
                fontWeight: 700,
            },
        },
        iconBtn: {
            padding: 0,
            marginLeft: theme.spacing(2),
        },
        companyName: {
            fontWeight: 500,
            color: theme.palette.primary.main,
        },
        paginationContainer: {
            display: "flex",
            justifyContent: "flex-end",
            marginTop: theme.spacing(3),
        },
        addButton: {
            minWidth: "200px",
        },
        circularProgress: {
            margin: "80px",
            width: "48px",
            height: "48px",
        },
        soldVolumesTotal: {
            "& .MuiTableCell-root": {
                fontWeight: 700,
                paddingTop: theme.spacing(1.5),
                paddingBottom: theme.spacing(1.5),
                paddingRight: theme.spacing(3.8),
            },
        },
        squareButton: {
            borderWidth: '6px',
            fontWeight: "bold",
            backgroundColor: 'transparent',
            borderColor: '#228B22',
        },
        nav: {
            marginTop: '40px',
            },
        pullRight: {
            float: 'right',
        },
        link: {
            color: '#333',
            textDecoration: 'none',
            '&:active': {
                color: '#333',
            },
            '&:hover': {
                color: '#999',
            },
        },
        completeStep: {
            borderWidth: '5px !important',
            borderColor: `${brandColors.success.bright} !important`,
            backgroundColor: brandColors.success.bright,
            paddingTop: '1px',
            paddingBottom: '1px',
            marginBottom: '10px',
            fontSize: '12px',
            fontWeight: 'bold',
            fontFamily: 'inherit',
            color: '#464e63 !important'
        },
        incompleteStep: {
            borderWidth: '5px !important',
            borderColor: '#ff4319 !important',
            backgroundColor: '#ff4319',
            paddingTop: '1px',
            paddingBottom: '1px',
            marginBottom: '10px',
            fontSize: '12px',
            fontWeight: 'bold',
            fontFamily: 'inherit',
            color: '#464e63 !important'
        },
        notActivatedStep: {
            borderWidth: '5px !important',
            borderColor: '#c2d1d9 !important',
            backgroundColor: '#c2d1d9',
            paddingTop: '1px',
            paddingBottom: '1px',
            marginBottom: '10px',
            fontSize: '12px',
            fontWeight: 'bold',
            fontFamily: 'inherit',
            color: '#464e63 !important'
        },
        overAllocated: {
            borderWidth: '5px !important',
            borderColor: `${brandColors.primary.light} !important`,
            backgroundColor: brandColors.primary.light,
            paddingTop: '1px',
            paddingBottom: '1px',
            marginBottom: '10px',
            fontSize: '12px',
            fontWeight: 'bold',
            fontFamily: 'inherit',
            color: '#464e63 !important'
        },
        ...overviewCardStyles(theme),
        ...arrowProgressBarStyles(theme),
    })
);

const ReportOverviewContainer: React.FC = () => {
    const classes = useStyles();
    const match = useRouteMatch();
    const history = useHistory();
    const dispatch = useDispatch();

    const isSimulation = useSelector((state: State) => state.sustainability.main.isSimulation);
    const activePeriod = useSelector((state: State) => state.sustainability.main.activePeriod);

    const [disableConfirm, setDisableConfirm] = useState<boolean>(false);

    const [areButtonsVisibleRoadUse, setAreButtonsVisibleRoadUse] = useState(false);
    const [areButtonsVisibleOffRoad, setAreButtonsVisibleOffRoad] = useState(false);
    const [areButtonsVisibleMarine, setAreButtonsVisibleMarine] = useState(false);
    const [marineDataId, setMarineDataId] = useState<any>(null);
    const [marineHasStep, setMarineHasStep] = useState<boolean>(false);
    const [roadUseId, setRoadUseId] = useState<any>(null);
    const [roadUseHasStep, setRoadUseHasStep] = useState<boolean>(false);
    const [offRoadUseId, setOffRoadUseId] = useState<any>(null);
    const [offRoadUseHasStep, setOffRoadUseHasStep] = useState<boolean>(false);
    const [confirmState, setConfirmState] = useState<boolean>(false);
    const [showModalDeleteRoaduse, setShowModalDeleteRoaduse] = useState<boolean>(false);
    const [showModalDeleteOffRoad, setShowModalDeleteOffRoad] = useState<boolean>(false);
    const [showModalDeleteMarine, setShowModalDeleteMarine] = useState<boolean>(false);
    const [roadUseLevels, setRoadUseLevels] = useState({
        general: "",
        gasolineSub: "",
        advancedSub: "",
    });
    const [offRoadLevels, setOffRoadLevels] = useState({
        general: "",
    });
    const [marineLevels, setMarineLevels] = useState({
        general: "",
    });

    const [mandateStatuses, setMandateStatuses] = useState({
        roaduseVolume: ["", ""],
        roaduseAllocation: ["", ""],
        roaduseReport: ["", ""],
        roaduseSteps: ["", "", "", "", "", ""],
        offroadVolume: ["", ""],
        offroadAllocation: ["", ""],
        offroadReport: ["", ""],
        offroadSteps: ["", "", "", "", ""],
        marineVolume: ["", ""],
        marineAllocation: ["", ""],
        marineReport: ["", ""],
        marineSteps: ["", "", "", ""],
    });

    const [errorMessage, setErrorMessage] = useState<string>("");
    const [showErrorModal, setShowErrorModal] = useState<boolean>(false);
    const [
    showConfirmDeliveryModal,
    setShowConfirmDeliveryModal,
] = useState<boolean>(false);

    const openErrorModal = (msg: string) => {
        setErrorMessage(msg);
        setShowErrorModal(true);
    };
    const closeErrorModal = () => {
        setErrorMessage("");
        setShowErrorModal(false);
    };

    const openConfirmDeliveryModal = () => {
        setShowConfirmDeliveryModal(true);
    };

    const closeConfirmDeliveryModal = () => {
        setShowConfirmDeliveryModal(false);
    };

    const openModalDeleteRoaduse = () => {
        setShowModalDeleteRoaduse(true);
    };
    const closeModalDeleteRoaduse = () => {
        setShowModalDeleteRoaduse(false);
    };

    const openModalDeleteOffRoad = () => {
        setShowModalDeleteOffRoad(true);
    };
    const closeModalDeleteOffRoad = () => {
        setShowModalDeleteOffRoad(false);
    };
    const openModalDeleteMarine = () => {
        setShowModalDeleteMarine(true);
    };
    const closeModalDeleteMarine = () => {
        setShowModalDeleteMarine(false);
    };
    const handleDraftReport = (mandateType:string) => {
        if (match) {
            history.push(`/sustainability/reports/${mandateType}`);
        }
    };

    const checkData = async () => {
        const roadUse = await hasRoadData();
        if (roadUse) {
            setRoadUseId(roadUse.id);
            setRoadUseHasStep(!!roadUse.last_active_step);
            setAreButtonsVisibleRoadUse(roadUse.mandate_enabled);
            setRoadUseLevels({
                general: parseAndFormat(roadUse.general_mandate, 2),
                gasolineSub: parseAndFormat(roadUse.gasoline_sub_mandate, 2),
                advancedSub: parseAndFormat(roadUse.advanced_sub_mandate, 2),
            });
        }

        const offRoadUse = await hasOffRoadData();
        if (offRoadUse) {
            setOffRoadUseId(offRoadUse.id);
            setOffRoadUseHasStep(!!offRoadUse.last_active_step);
            setAreButtonsVisibleOffRoad(offRoadUse.mandate_enabled);
            setOffRoadLevels({
                general: parseAndFormat(offRoadUse.general_mandate, 2),
            });
        }

        const marine = await hasMarineData();
        if (marine) {
            setMarineDataId(marine.id);
            setMarineHasStep(!!marine.last_active_step);
            setAreButtonsVisibleMarine(marine.mandate_enabled);
            setMarineLevels({
                general: parseAndFormat(marine.general_mandate, 2),
            });
        }

        await checkConfirmationStatus();
        checkDisableConfirmation();
        const statusData = await getMandateStatuses();
        if (statusData) {
            setMandateStatuses({
                roaduseVolume: statusData.roaduseVolume,
                roaduseAllocation: statusData.roaduseAllocation,
                roaduseReport: statusData.roaduseReport,
                roaduseSteps: statusData.roaduseSteps,
                offroadVolume: statusData.offroadVolume,
                offroadAllocation: statusData.offroadAllocation,
                offroadReport: statusData.offroadReport,
                offroadSteps: statusData.offroadSteps,
                marineVolume: statusData.marineVolume,
                marineAllocation: statusData.marineAllocation,
                marineReport: statusData.marineReport,
                marineSteps: statusData.marineSteps,
            });
        }
    };
    const deleteOffRoadVolume = async () => {
        await deleteData("off-road-use", offRoadUseId);
    };
    const deleteData = async ( type: string, id: any ) => {
        switch (type) {
            case "road-use" :
                await deleteRoadUseData(id);
                await resetAllocation();
                break;
            case "off-road-use" :
                await deleteOffRoadUseData(id, type);
                await resetAllocationOffroad();
                break;
            case "marine" :
                await deleteOffRoadUseData(id, type);
                // await deleteMarineData(id);
                break;
            default :
                console.log("no matched data");
        }
        await checkData();
        closeModalDeleteRoaduse(); // Close the modal after deletion
    };
    const isMounted = useRef(true);

    const handleZipDownload = async (type: Zfiletype) => {
        const response = await getDownloadZipReport({
            type,
            // @ts-ignore
            taxYear: activePeriod.year,
        });
        if (response === null) {
            openErrorModal(
                "Failed to download file: Possible errors: no file for selected year or other errors."
            );
        }

        if (response !== null) {
            // emulate file download by clicking on an <a /> link
            const url = window.URL.createObjectURL(response);
            const fileName =
                type === "draft_report_excel"
                    ? "sustainability-draft-report"
                    : "sustainability-report";
            const fileExt = "zip";

            const a = document.createElement("a");
            a.href = url;
            // @ts-ignore
            a.download = `${fileName}-${activePeriod.year}.${fileExt}`;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    };

    const handleDownload = async (type: Tfiletype, mandate_type: Tmandate_type) => {
        const response = await getDownloadReport({
            type,
            mandate_type,
            // @ts-ignore
            taxYear: activePeriod.year,
        });
        if (response === null) {
            openErrorModal(
                "Failed to download file: Possible errors: no file for selected year or other errors."
            );
        }

        if (response !== null) {
            // emulate file download by clicking on an <a /> link
            const url = window.URL.createObjectURL(response);
            const fileName =
                type === "draft_report_excel"
                    ? "sustainability-draft-report"
                    : type.indexOf("sub") > -1
                        ? "sustainability-subreport"
                        : "sustainability-report";
            const fileExt = type.indexOf("excel") > -1 ? "xlsx" : "json";

            const a = document.createElement("a");
            a.href = url;
            // @ts-ignore
            a.download = `${fileName}-${mandate_type}-${activePeriod.year}.${fileExt}`;
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
    };

    const handleConfirmationStatus = async () => {
        if (activePeriod && activePeriod.year) {
            // @ts-ignore
            const res = await getConfirmState({ taxYear: activePeriod.year });
            if (res === null) {
                openErrorModal(
                    "Failed to confirm delivery. Possible errors: correct reporting year is not selected or other errors."
                );
            } else {
                openErrorModal(
                    "Delivery Confirmed."
                );
            }
            checkData();
        }
    };

    const checkConfirmationStatus = async () => {
        if (activePeriod && activePeriod.year) {
            // @ts-ignore
            const confirmState = await checkConfirmState({taxYear: activePeriod.year});
            setConfirmState(confirmState);
        }
    };

    const checkDisableConfirmation = async () => {
        if (activePeriod && activePeriod.year) {
            // @ts-ignore
            // tslint:disable-next-line:no-shadowed-variable
            let disableConfirm: any;
            disableConfirm = await checkDisableConfirm({taxYear: activePeriod.year});
            setDisableConfirm(disableConfirm);
        }
    };

    useEffect(() => {
        if (!activePeriod) {
            return;
        }
        const params = {
            allocation: isSimulation ? "Simulation" : "Reporting",
            fulfilment: "own",
            // @ts-ignore
            taxYearId: activePeriod.id,
        };

        getAllocationPageData(params);
        checkData();

    }, [isSimulation, activePeriod]);

    useEffect(() => {
        isMounted.current = true;
        if (isMounted.current) {
            checkData();
        }
        return () => {
            isMounted.current = false;
        };
    }, []);
    const currentYear = new Date().getFullYear();
    // @ts-ignore
    return (
        <div>
            <h1>Reporting Overview</h1>
            {activePeriod &&  (
            <>
            <div className={classes.cardContainer}>
                <Card className={`${classes.card} ${classes.cardReport}`}>
                    <CardContent className={classes.cardContent}>
                        <Typography variant="h5" className={classes.toggleCardTitle}>
                            <FormattedMessage id="allocationView.mainView.allocationMode"/>
                        </Typography>

                        <ToggleButton
                            labels={[`Reporting ${currentYear - 1}`, `Simulation ${currentYear}`]}
                            defaultLabelIndex={isSimulation ? 1 : 0}
                            handleChange={() => dispatch(toggleSimulation())}
                        />
                    </CardContent>
                </Card>
                <Card className={`${classes.card} ${classes.cardAllocation}`}>
                    <CardContent className={classes.cardContent}>
                        <Typography variant="h5" className={classes.cardTitle}>
                            <p>Report File and Actions</p>
                        </Typography>
                        <Grid container spacing={3}>
                            <Grid item xs={4}>
                                <ButtonRounded
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={() => handleZipDownload("draft_report_excel")}
                                >
                                    Draft Report (Excel)
                                </ButtonRounded>
                            </Grid>
                            <Grid item xs={4}>
                                <ButtonRounded
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={() => handleZipDownload("report_excel")}
                                >
                                    Tilde rep. files (ZIP)
                                </ButtonRounded>
                            </Grid>
                            <Grid item xs={4}>
                                <ButtonRounded
                                    variant="outlined"
                                    color="default"
                                    fullWidth
                                    onClick={openConfirmDeliveryModal}
                                    disabled={disableConfirm || confirmState}
                                >
                                    {confirmState ? (
                                        <FormattedMessage id="sustainabilityView.reportsView.confirmed" />
                                    ) : (
                                            <FormattedMessage id="loginView.confirm" />
                                        )}{" "}
                                    <FormattedMessage id="sustainabilityView.reportsView.delivery" />
                                </ButtonRounded>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </div>

            <Card className={`${classes.card}`}>
                {areButtonsVisibleRoadUse &&  <CardContent className={classes.cardContent}>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <h1>Road use mandate for {activePeriod ? activePeriod.year : currentYear - 1}</h1>
                            <Grid item xs={9}>
                                <p>The road use mandate in {activePeriod ? activePeriod.year : currentYear - 1} is {roadUseLevels.general} %.
                                    In addition to the general mandate level, the road use mandate also contains
                                    separate sub-mandates for gasoline ({roadUseLevels.gasolineSub} %) and minimum
                                    volume of biofuels with advanced sustainability criteria
                                    ({roadUseLevels.advancedSub} %).</p>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <div className={classes.containerArrowProgressbar}>
                                        <div className={classes.wrapper}>
                                            <div className={`${classes.arrowSteps} ${classes.clearfixAfter}`}>
                                                <div className={`step ${mandateStatuses.roaduseVolume[0]}`}>
                                                    <span>{mandateStatuses.roaduseVolume[1]}</span>
                                                </div>
                                                <div className={`step ${mandateStatuses.roaduseAllocation[0]}`}>
                                                    <span>{mandateStatuses.roaduseAllocation[1]}</span>
                                                </div>
                                                <div className={`step ${mandateStatuses.roaduseReport[0]}`}>
                                                    <span>{mandateStatuses.roaduseReport[1]}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={3}>

                                    <ButtonRounded
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() => handleDraftReport("roaduse")}
                                        className={classes.buttonMargin}
                                        disabled={false}
                                    >
                                        View draft report
                                    </ButtonRounded>

                                </Grid>
                                <Grid item xs={3}>
                                    <ButtonRounded
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() => handleDownload("draft_report_excel", "roaduse")}
                                        className={classes.buttonMargin}
                                        disabled={false}
                                    >
                                        Draft report (Excel)
                                    </ButtonRounded>

                                </Grid>
                                <Grid item xs={3}>
                                    <ButtonRounded
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() => handleDownload("report_excel", "roaduse")}
                                        disabled={false}
                                    >
                                        Tilde report file
                                    </ButtonRounded>
                                </Grid>
                            </Grid>
                            {showModalDeleteRoaduse && (
                                <>
                                    <ModalDeleteVolumeInMandate
                                        open={showModalDeleteRoaduse}
                                        handleDelete={async () => {
                                            // await deleteData("road-use", roadUseId);
                                            await deleteRoadUseData(roadUseId);
                                            await resetAllocation();
                                            await checkData();
                                            window.location.reload();
                                        }}
                                        onClose={closeModalDeleteRoaduse}
                                    />
                                </>
                            )}
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5" className={classes.toggleCardTitle}>
                                <p>Allocation status</p>
                            </Typography>

                            <ButtonSquare
                                variant="outlined"
                                color ="primary"
                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.roaduseSteps[0]]}`}
                                disabled={roadUseId !== null}
                            >
                                Surplus Volumes
                            </ButtonSquare>
                            <ButtonSquare
                                variant="outlined"
                                color ="primary"
                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.roaduseSteps[1]]}`}
                                disabled={roadUseId !== null}
                            >
                                Advanced sub-mandate
                            </ButtonSquare>
                            <ButtonSquare
                                variant="outlined"
                                color ="primary"
                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.roaduseSteps[2]]}`}
                                disabled={roadUseId !== null}
                            >
                                General mandate
                            </ButtonSquare>
                            <ButtonSquare
                                variant="outlined"
                                color ="primary"
                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.roaduseSteps[3]]}`}
                                disabled={roadUseId !== null}
                            >
                                Bio above mandate (required)
                            </ButtonSquare>
                            <ButtonSquare
                                variant="outlined"
                                color ="primary"
                                fullWidth
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.roaduseSteps[5]]}`}
                                disabled={roadUseId !== null}
                            >
                                Joint fulfillment
                            </ButtonSquare>
                            <ButtonSquare
                                variant="outlined"
                                color ="primary"
                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.roaduseSteps[4]]}`}
                                disabled={roadUseId !== null}
                            >
                                Bio above mandate
                            </ButtonSquare>
                        </Grid>
                    </Grid>
                </CardContent>}
            </Card>

            <Card className={`${classes.card}`}>
                { areButtonsVisibleOffRoad && <CardContent className={classes.cardContent}>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <h1>Off-road mandate for {activePeriod ? activePeriod.year : currentYear - 1}</h1>
                            <p>The off-road mandate in {activePeriod ? activePeriod.year : currentYear - 1} is {offRoadLevels.general} %. Fulfillment
                                of this mandate is only possible with biofuels that have advanced sustainability criteria.</p>

                            {areButtonsVisibleOffRoad && (<Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <div className={classes.containerArrowProgressbar}>
                                        <div className={classes.wrapper}>
                                            <div className={`${classes.arrowSteps} ${classes.clearfixAfter}`}>
                                                <div className={`step ${mandateStatuses.offroadVolume[0]}`}>
                                                    <span>{mandateStatuses.offroadVolume[1]}</span>
                                                </div>
                                                <div className={`step ${mandateStatuses.offroadAllocation[0]}`}>
                                                    <span>{mandateStatuses.offroadAllocation[1]}</span>
                                                </div>
                                                <div className={`step ${mandateStatuses.offroadReport[0]}`}>
                                                    <span>{mandateStatuses.offroadReport[1]}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={3}>
                                    <ButtonRounded
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() => handleDraftReport("offroad")}
                                        className={classes.buttonMargin}
                                        disabled={false}
                                    >
                                        View draft report
                                    </ButtonRounded>

                                </Grid>
                                <Grid item xs={3}>

                                    <ButtonRounded
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() => handleDownload("draft_report_excel", "offroad")}
                                        className={classes.buttonMargin}
                                        disabled={false}
                                    >
                                        Draft report (Excel)
                                    </ButtonRounded>

                                </Grid>
                                <Grid item xs={3}>

                                    <ButtonRounded
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() => handleDownload("report_excel","offroad")}
                                        disabled={false}
                                    >
                                        Tilde report file
                                    </ButtonRounded>
                                </Grid>
                            </Grid>)}
                            {showModalDeleteOffRoad && (
                                <>
                                    <ModalDeleteVolumeInMandate
                                        open={showModalDeleteOffRoad}
                                        handleDelete={()=>{
                                            deleteOffRoadVolume().then(() => {
                                                closeModalDeleteOffRoad(); // Close the modal after deletion
                                                window.location.reload(); // Reload the page after successful deletion
                                            });
                                        }}
                                        onClose={closeModalDeleteOffRoad}
                                    />
                                </>
                            )}
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5" className={classes.toggleCardTitle}>
                                <p>Allocation status</p>
                            </Typography>

                            <ButtonSquare
                                variant="outlined"
                                color ="primary"

                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.offroadSteps[4]]}`}
                                disabled={roadUseId !== null}
                            >
                                Surplus Volumes
                            </ButtonSquare>

                            <ButtonSquare
                                variant="outlined"
                                color ="primary"

                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.offroadSteps[0]]}`}
                                disabled={roadUseId !== null}
                            >
                                General mandate
                            </ButtonSquare>

                            <ButtonSquare
                                variant="outlined"
                                color ="primary"
                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.offroadSteps[1]]}`}
                                disabled={roadUseId !== null}
                            >
                                Bio above mandate (required)
                            </ButtonSquare>
                            <ButtonSquare
                                variant="outlined"
                                color ="primary"
                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.offroadSteps[3]]}`}
                                disabled={roadUseId !== null}
                            >
                                Joint fulfillment
                            </ButtonSquare>
                            <ButtonSquare
                                variant="outlined"
                                color ="primary"

                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.offroadSteps[2]]}`}
                                disabled={roadUseId !== null}
                            >
                                Bio above mandate
                            </ButtonSquare>
                        </Grid>
                    </Grid>
                </CardContent>}
            </Card>



            <Card className={`${classes.card}`}>
                { areButtonsVisibleMarine && <CardContent className={classes.cardContent}>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <h1>Marine mandate for {activePeriod ? activePeriod.year : currentYear - 1}</h1>
                            <p>The marine mandate in {activePeriod ? activePeriod.year : currentYear - 1} is {marineLevels.general} %. Fulfillment
                                of this mandate is only possible with biofuels that have advanced sustainability criteria.</p>

                            {areButtonsVisibleMarine && (<Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <div className={classes.containerArrowProgressbar}>
                                        <div className={classes.wrapper}>
                                            <div className={`${classes.arrowSteps} ${classes.clearfixAfter}`}>
                                                <div className={`step ${mandateStatuses.marineVolume[0]}`}>
                                                    <span>{mandateStatuses.marineVolume[1]}</span>
                                                </div>
                                                <div className={`step ${mandateStatuses.marineAllocation[0]}`}>
                                                    <span>{mandateStatuses.marineAllocation[1]}</span>
                                                </div>
                                                <div className={`step ${mandateStatuses.marineReport[0]}`}>
                                                    <span>{mandateStatuses.marineReport[1]}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={3}>

                                    <ButtonRounded
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() => handleDraftReport('marine')}
                                        className={classes.buttonMargin}
                                        disabled={false}
                                    >
                                        View draft report
                                    </ButtonRounded>

                                </Grid>
                                <Grid item xs={3}>

                                    <ButtonRounded
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() => handleDownload("draft_report_excel","marine")}
                                        className={classes.buttonMargin}
                                        disabled={false}
                                    >
                                        Draft report (Excel)
                                    </ButtonRounded>

                                </Grid>
                                <Grid item xs={3}>

                                    <ButtonRounded
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        onClick={() => handleDownload("report_excel","marine")}
                                        disabled={false}
                                    >
                                        Tilde report file
                                    </ButtonRounded>
                                </Grid>
                            </Grid>)}
                        </Grid>
                        <Grid item xs={3}>
                            <Typography variant="h5" className={classes.toggleCardTitle}>
                                <p>Mandate settings</p>
                            </Typography>

                            <ButtonSquare
                                variant="outlined"
                                color ="primary"

                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.marineSteps[0]]}`}
                                disabled={roadUseId !== null}
                            >
                                General mandate
                            </ButtonSquare>

                            <ButtonSquare
                                variant="outlined"
                                color ="primary"
                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.marineSteps[1]]}`}
                                disabled={roadUseId !== null}
                            >
                                Bio above mandate (required)
                            </ButtonSquare>
                            <ButtonSquare
                                variant="outlined"
                                color ="primary"
                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.marineSteps[3]]}`}
                                disabled={roadUseId !== null}
                            >
                                Joint fulfillment
                            </ButtonSquare>
                            <ButtonSquare
                                variant="outlined"
                                color ="primary"

                                fullWidth
                                // onClick={handleRoadUseVolume}
                                className={`${classes.buttonMargin} ${classes[mandateStatuses.marineSteps[2]]}`}
                                disabled={roadUseId !== null}
                            >
                                Bio above mandate
                            </ButtonSquare>
                        </Grid>
                    </Grid>
                </CardContent>}

            </Card>

            <ModalInfo
                text={errorMessage}
                open={showErrorModal}
                onClose={closeErrorModal}
            />
            <ModalConfirmDelivery
                open={showConfirmDeliveryModal}
                onClose={closeConfirmDeliveryModal}
                onConfirm={() => {
                    closeConfirmDeliveryModal();
                    handleConfirmationStatus();
                }}
            />
            </>
            )}
        </div>
    );
};
export default ReportOverviewContainer;
